import React, { useEffect } from "react";
import styles from "./index.module.scss";
import ButtonC from "../../common/button";
import OtpInputC from "../../common/otpInput";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useInvestorOTP } from "../../../hooks/react-query/investor/useInvestorOTP";
import { useInvestorResendOTP } from "../../../hooks/react-query/investor/useInvestorResendOTP";
import useContextHook from "../../../hooks/context/useContext";
import {
  ChangeMobileNo,
  ResendOTPClicked,
  VerifyButtonClicked
} from "../amplitude";

export default function OtpVerificationC() {
  const { mobileNumber, setMobileNumber } = useContextHook();
  const [otp, setOtp] = React.useState("");
  const [error, setError] = React.useState("");
  const [timer, setTimer] = React.useState(30);
  const navigate = useNavigate();
  const timerRef = React.useRef<NodeJS.Timeout | null>(null);
  const [searchParams] = useSearchParams();
  const continueParam: any = searchParams.get("continue");
  const continueUrl = new URL(continueParam, window.location.origin);

  const otpMutation: any = useInvestorOTP(
    (data: any) => {
      const continueParam = searchParams.get("continue");
      if (continueParam) {
        navigate(continueParam);
      } else {
        navigate("/investor/properties-listing");
      }
      setError("");
      localStorage.setItem("investor-access-token", data.data.access_token);
      VerifyButtonClicked({
        contactId: data?.data?.contactId,
        sfid: data?.data?.sfid,
        mobileNumber: mobileNumber,
        linkCId: continueUrl.searchParams.get("cid") || "",
        linkEmailId: continueUrl.searchParams.get("eq") || ""
      });
      setOtp("");
    },
    (error: any) => {
      setError(error.response.data.message);
    }
  );

  const resendOtpMutation: any = useInvestorResendOTP(
    (data: any) => {},
    (error: any) => {
      setError(error.response.data.message);
    }
  );

  React.useEffect(() => {
    if (timer > 0) {
      timerRef.current = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [timer]);

  useEffect(() => {
    if (otp.length === 6) {
      handleLoginClick();
    }
  }, [otp]);

  const handleLoginClick = () => {
    if (!otp) {
      setError("Please enter a OTP");
      return;
    } else {
      otpMutation.mutate({ otp: otp, mobile: mobileNumber });
    }
  };

  const ResendOTP = () => {
    resendOtpMutation.mutate({ mobile: mobileNumber });
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    setTimer(30);
    ResendOTPClicked({
      mobileNumber: mobileNumber,
      linkCId: continueUrl.searchParams.get("cid") || "",
      linkEmailId: continueUrl.searchParams.get("eq") || ""
    });
  };

  const handleChangeMobile = () => {
    setMobileNumber("");
    const continueParam = searchParams.get("continue");
    if (continueParam) {
      navigate(`/investor-login?continue=${encodeURIComponent(continueParam)}`);
    } else {
      navigate("/investor-login");
    }
    ChangeMobileNo({
      mobileNumber: mobileNumber,
      linkCId: continueUrl.searchParams.get("cid") || "",
      linkEmailId: continueUrl.searchParams.get("eq") || ""
    });
  };
  return (
    <div className={styles.loginBox}>
      <div className={styles.heading}>
        <img src="/images/logo.svg" alt="" className={styles.logo} />
      </div>
      <div className={styles.titleWrap}>
        <div className={styles.title}>Enter OTP</div>
        <div className={styles.MobileNumber}>
          OTP sent to <span className={styles.star}>**** ***</span>{" "}
          {mobileNumber.slice(-4)}
        </div>
        <div className={styles.changeMobile}>
          <span
            // onClick={() => {
            //   setMobileNumber("");
            //   navigate("/investor-login");
            // }}
            onClick={handleChangeMobile}
          >
            Change mobile number
          </span>
        </div>
      </div>
      <div className={styles.InputWrap}>
        <OtpInputC
          value={otp}
          onChange={(e) => {
            setOtp(e);
            setError("");
          }}
          numInputs={6}
          inputStyle={styles.otpBox}
          renderSeparator={
            <span>
              <img src="/images/dash.svg" alt="" />
            </span>
          }
          renderInput={(props: any) => <input {...props} />}
        />
        <div className={styles.error}>{error}</div>
        <ButtonC
          type="button"
          className={styles.SalesforceBtn}
          label="Verify"
          bgColor={"blueBg"}
          tabIndex={1}
          onClick={handleLoginClick}
          disabled={otp.length < 6}
          loading={otpMutation.isPending}
        />
      </div>
      <div className={styles.resendWrap}>
        <span>Didn’t receive the Code?</span>
        {timer === 0 ? (
          <span className={styles.resend} onClick={ResendOTP}>
            Resend OTP
          </span>
        ) : (
          <span>Resend OTP in {timer}s</span>
        )}
      </div>
    </div>
  );
}
